"use strict";
window.showHideAnswer = showHideAnswer;
function showHideAnswer(id) {
    let fullList = document.querySelector(`#faq-${id} .faq__answer__text__full`);
    let resumeList = document.querySelector(`#faq-${id} .faq__answer__text__resume`);
    let button = document.querySelector(`#faq-${id} .ev-btn-link`);
    if (fullList === null || fullList === void 0 ? void 0 : fullList.classList.contains('d-none')) {
        resumeList === null || resumeList === void 0 ? void 0 : resumeList.classList.add('d-none');
        fullList === null || fullList === void 0 ? void 0 : fullList.classList.remove('d-none');
        button.innerHTML = 'Ocultar respuesta';
    }
    else {
        fullList === null || fullList === void 0 ? void 0 : fullList.classList.add('d-none');
        resumeList === null || resumeList === void 0 ? void 0 : resumeList.classList.remove('d-none');
        button.innerHTML = 'Mostrar respuesta completa';
    }
}
